import React, { useState } from 'react';
import { SimpleModal } from '../../../../components/Modal';
import { StyledButton } from '../../../../components/Buttons/DefaultButton/DefaultButton.styles';
import { CameraIcon } from '../ProfilePage.styles';

type Props = {
  imageSrc: string | null;
  onUpload: () => void;
  onRequestRemove: () => void;
};

export const ProfilePhotoActions: React.FC<Props> = ({ imageSrc, onUpload, onRequestRemove }) => {
  const [actionsOpen, setActionsOpen] = useState(false);
  const [viewerOpen, setViewerOpen] = useState(false);
  const hasImage = Boolean(imageSrc);

  const openUpload = () => {
    setActionsOpen(false);
    onUpload();
  };

  return (
    <>
      <div
        style={{
          position: 'relative',
          width: '8rem',
          height: '8rem',
          alignSelf: 'center',
          display: 'inline-block',
        }}
      >
        <button
          type="button"
          className="profile-photo-parent no-fastclick"
          aria-label={hasImage ? 'Profile image options' : 'Upload profile image'}
          data-testid="profile-photo-action-button"
          onClick={() => setActionsOpen(true)}
          style={{ border: 0, padding: 0, background: 'transparent', cursor: 'pointer' }}
        >
          {imageSrc
            ? <img className="photoImg" src={imageSrc} alt="Profile" />
            : <CameraIcon />}
        </button>
        {hasImage && (
          <button
            type="button"
            aria-label="Remove profile photo"
            data-testid="remove-profile-photo-button"
            onClick={(event) => {
              event.stopPropagation();
              event.preventDefault();
              onRequestRemove();
            }}
            style={{
              position: 'absolute',
              top: 0,
              right: 0,
              width: 32,
              height: 32,
              borderRadius: '50%',
              border: '2px solid #fff',
              background: '#FB7672',
              color: '#fff',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 20,
              fontWeight: 700,
              lineHeight: 1,
              padding: 0,
              boxShadow: '0 2px 4px rgba(0,0,0,0.25)',
              zIndex: 10,
            }}
          >
            ×
          </button>
        )}
      </div>

      <SimpleModal isOpen={actionsOpen} onClose={() => setActionsOpen(false)}>
        <div style={{ padding: '1rem' }} data-testid="profile-photo-actions-modal">
          <h2 style={{ margin: '0 0 1rem' }}>Profile Image</h2>
          <div style={{ display: 'grid', gap: 8 }}>
            <StyledButton data-testid="profile-photo-upload" variant="contained" size="large" onClick={openUpload}>
              Upload Image
            </StyledButton>
            {hasImage && (
              <StyledButton
                variant="outlined"
                size="large"
                data-testid="profile-photo-view"
                onClick={() => {
                  setActionsOpen(false);
                  setViewerOpen(true);
                }}
              >
                View Profile Image
              </StyledButton>
            )}
            <StyledButton data-testid="profile-photo-actions-cancel" variant="outlined" size="large" onClick={() => setActionsOpen(false)}>
              Cancel
            </StyledButton>
          </div>
        </div>
      </SimpleModal>

      <SimpleModal isOpen={viewerOpen} onClose={() => setViewerOpen(false)}>
        <div style={{ padding: '1rem', textAlign: 'center' }} data-testid="profile-photo-viewer-modal">
          <h2 style={{ margin: '0 0 1rem' }}>Profile Image</h2>
          {imageSrc && (
            <img
              src={imageSrc}
              alt="Full-size profile"
              style={{ display: 'block', maxWidth: '100%', maxHeight: '70vh', margin: '0 auto 1rem' }}
            />
          )}
          <StyledButton data-testid="profile-photo-viewer-close" variant="outlined" size="large" onClick={() => setViewerOpen(false)}>
            Close
          </StyledButton>
        </div>
      </SimpleModal>
    </>
  );
};

export default ProfilePhotoActions;
